import React from 'react';
import { func, string } from 'prop-types';
import Icon from '../Icon/Icon';
import WithPlaceholder from '../../hoc/WithPlaceholder';

const propTypes = {
  onChange: func.isRequired,
  query: string,
};
const defaultProps = {
  query: '',
};

const OffersSearch = ({ onChange, query }) => (
  <div className="search-field">
    <WithPlaceholder
      placeholder="offers.filters.search"
      defaultMessage="Search"
      bsSize="xs"
      type="text"
      onChange={onChange}
      value={query}
      autoComplete="off"
    />
  </div>
);

OffersSearch.propTypes = propTypes;
OffersSearch.defaultProps = defaultProps;

export default OffersSearch;
